// User Authentication & Verification System for ONTAP Global
// For Foreign Master's Graduate Engineers in USA & Canada
// Uses localStorage for MVP - can be migrated to backend later

const USERS_KEY = 'ontap_users';
const CURRENT_USER_KEY = 'ontap_current_user';
const ADMIN_EMAIL = 'heyrams16@gmail.com'; // Admin email for verification
const EXPIRY_DAYS = 7; // Days before unverified users expire

// USA & Canada Universities with Engineering Programs
export const universities = {
  usa: [
    // Top Engineering Schools - USA
    { id: 'mit', name: 'Massachusetts Institute of Technology (MIT)', state: 'MA', domain: 'mit.edu' },
    { id: 'stanford', name: 'Stanford University', state: 'CA', domain: 'stanford.edu' },
    { id: 'berkeley', name: 'UC Berkeley', state: 'CA', domain: 'berkeley.edu' },
    { id: 'cmu', name: 'Carnegie Mellon University', state: 'PA', domain: 'cmu.edu' },
    { id: 'gatech', name: 'Georgia Institute of Technology', state: 'GA', domain: 'gatech.edu' },
    { id: 'caltech', name: 'California Institute of Technology', state: 'CA', domain: 'caltech.edu' },
    { id: 'umich', name: 'University of Michigan', state: 'MI', domain: 'umich.edu' },
    { id: 'uiuc', name: 'University of Illinois Urbana-Champaign', state: 'IL', domain: 'illinois.edu' },
    { id: 'cornell', name: 'Cornell University', state: 'NY', domain: 'cornell.edu' },
    { id: 'purdue', name: 'Purdue University', state: 'IN', domain: 'purdue.edu' },
    { id: 'utaustin', name: 'University of Texas at Austin', state: 'TX', domain: 'utexas.edu' },
    { id: 'ucla', name: 'University of California, Los Angeles', state: 'CA', domain: 'ucla.edu' },
    { id: 'ucsd', name: 'University of California, San Diego', state: 'CA', domain: 'ucsd.edu' },
    { id: 'usc', name: 'University of Southern California', state: 'CA', domain: 'usc.edu' },
    { id: 'northwestern', name: 'Northwestern University', state: 'IL', domain: 'northwestern.edu' },
    { id: 'columbia', name: 'Columbia University', state: 'NY', domain: 'columbia.edu' },
    { id: 'upenn', name: 'University of Pennsylvania', state: 'PA', domain: 'upenn.edu' },
    { id: 'princeton', name: 'Princeton University', state: 'NJ', domain: 'princeton.edu' },
    { id: 'tamu', name: 'Texas A&M University', state: 'TX', domain: 'tamu.edu' },
    { id: 'umd', name: 'University of Maryland', state: 'MD', domain: 'umd.edu' },
    { id: 'wisc', name: 'University of Wisconsin-Madison', state: 'WI', domain: 'wisc.edu' },
    { id: 'osu', name: 'Ohio State University', state: 'OH', domain: 'osu.edu' },
    { id: 'umn', name: 'University of Minnesota', state: 'MN', domain: 'umn.edu' },
    { id: 'vt', name: 'Virginia Tech', state: 'VA', domain: 'vt.edu' },
    { id: 'psu', name: 'Penn State University', state: 'PA', domain: 'psu.edu' },
    { id: 'duke', name: 'Duke University', state: 'NC', domain: 'duke.edu' },
    { id: 'rice', name: 'Rice University', state: 'TX', domain: 'rice.edu' },
    { id: 'jhu', name: 'Johns Hopkins University', state: 'MD', domain: 'jhu.edu' },
    { id: 'brown', name: 'Brown University', state: 'RI', domain: 'brown.edu' },
    { id: 'dartmouth', name: 'Dartmouth College', state: 'NH', domain: 'dartmouth.edu' },
    { id: 'yale', name: 'Yale University', state: 'CT', domain: 'yale.edu' },
    { id: 'harvard', name: 'Harvard University', state: 'MA', domain: 'harvard.edu' },
    { id: 'uw', name: 'University of Washington', state: 'WA', domain: 'uw.edu' },
    { id: 'ufl', name: 'University of Florida', state: 'FL', domain: 'ufl.edu' },
    { id: 'asu', name: 'Arizona State University', state: 'AZ', domain: 'asu.edu' },
    { id: 'ncsu', name: 'North Carolina State University', state: 'NC', domain: 'ncsu.edu' },
    { id: 'bu', name: 'Boston University', state: 'MA', domain: 'bu.edu' },
    { id: 'neu', name: 'Northeastern University', state: 'MA', domain: 'northeastern.edu' },
    { id: 'nyu', name: 'New York University', state: 'NY', domain: 'nyu.edu' },
    { id: 'rutgers', name: 'Rutgers University', state: 'NJ', domain: 'rutgers.edu' },
    { id: 'njit', name: 'New Jersey Institute of Technology', state: 'NJ', domain: 'njit.edu' },
    { id: 'spu', name: 'Saint Peters University', state: 'NJ', domain: 'saintpeters.edu' },
    { id: 'stevens', name: 'Stevens Institute of Technology', state: 'NJ', domain: 'stevens.edu' },
    { id: 'uci', name: 'University of California, Irvine', state: 'CA', domain: 'uci.edu' },
    { id: 'ucdavis', name: 'University of California, Davis', state: 'CA', domain: 'ucdavis.edu' },
    { id: 'ucsb', name: 'University of California, Santa Barbara', state: 'CA', domain: 'ucsb.edu' },
    { id: 'ucsc', name: 'University of California, Santa Cruz', state: 'CA', domain: 'ucsc.edu' },
    { id: 'sjsu', name: 'San Jose State University', state: 'CA', domain: 'sjsu.edu' },
    { id: 'calpoly', name: 'California Polytechnic State University', state: 'CA', domain: 'calpoly.edu' },
    { id: 'utdallas', name: 'University of Texas at Dallas', state: 'TX', domain: 'utdallas.edu' },
    { id: 'uh', name: 'University of Houston', state: 'TX', domain: 'uh.edu' },
    { id: 'smu', name: 'Southern Methodist University', state: 'TX', domain: 'smu.edu' },
    { id: 'cu', name: 'University of Colorado Boulder', state: 'CO', domain: 'colorado.edu' },
    { id: 'csu', name: 'Colorado State University', state: 'CO', domain: 'colostate.edu' },
    { id: 'ua', name: 'University of Arizona', state: 'AZ', domain: 'arizona.edu' },
    { id: 'unlv', name: 'University of Nevada Las Vegas', state: 'NV', domain: 'unlv.edu' },
    { id: 'unr', name: 'University of Nevada Reno', state: 'NV', domain: 'unr.edu' },
    { id: 'oregonstate', name: 'Oregon State University', state: 'OR', domain: 'oregonstate.edu' },
    { id: 'uoregon', name: 'University of Oregon', state: 'OR', domain: 'uoregon.edu' },
    { id: 'wsu', name: 'Washington State University', state: 'WA', domain: 'wsu.edu' },
    { id: 'unc', name: 'University of North Carolina', state: 'NC', domain: 'unc.edu' },
    { id: 'clemson', name: 'Clemson University', state: 'SC', domain: 'clemson.edu' },
    { id: 'uva', name: 'University of Virginia', state: 'VA', domain: 'virginia.edu' },
    { id: 'gmu', name: 'George Mason University', state: 'VA', domain: 'gmu.edu' },
    { id: 'gwu', name: 'George Washington University', state: 'DC', domain: 'gwu.edu' },
    { id: 'drexel', name: 'Drexel University', state: 'PA', domain: 'drexel.edu' },
    { id: 'temple', name: 'Temple University', state: 'PA', domain: 'temple.edu' },
    { id: 'pitt', name: 'University of Pittsburgh', state: 'PA', domain: 'pitt.edu' },
    { id: 'case', name: 'Case Western Reserve University', state: 'OH', domain: 'case.edu' },
    { id: 'uc', name: 'University of Cincinnati', state: 'OH', domain: 'uc.edu' },
    { id: 'msu', name: 'Michigan State University', state: 'MI', domain: 'msu.edu' },
    { id: 'iub', name: 'Indiana University Bloomington', state: 'IN', domain: 'indiana.edu' },
    { id: 'uiowa', name: 'University of Iowa', state: 'IA', domain: 'uiowa.edu' },
    { id: 'isu', name: 'Iowa State University', state: 'IA', domain: 'iastate.edu' },
    { id: 'unl', name: 'University of Nebraska-Lincoln', state: 'NE', domain: 'unl.edu' },
    { id: 'ku', name: 'University of Kansas', state: 'KS', domain: 'ku.edu' },
    { id: 'mizzou', name: 'University of Missouri', state: 'MO', domain: 'missouri.edu' },
    { id: 'wustl', name: 'Washington University in St. Louis', state: 'MO', domain: 'wustl.edu' },
  ],
  canada: [
    // Top Engineering Schools - Canada
    { id: 'uoft', name: 'University of Toronto', province: 'ON', domain: 'utoronto.ca' },
    { id: 'ubc', name: 'University of British Columbia', province: 'BC', domain: 'ubc.ca' },
    { id: 'mcgill', name: 'McGill University', province: 'QC', domain: 'mcgill.ca' },
    { id: 'waterloo', name: 'University of Waterloo', province: 'ON', domain: 'uwaterloo.ca' },
    { id: 'ualberta', name: 'University of Alberta', province: 'AB', domain: 'ualberta.ca' },
    { id: 'mcmaster', name: 'McMaster University', province: 'ON', domain: 'mcmaster.ca' },
    { id: 'uottawa', name: 'University of Ottawa', province: 'ON', domain: 'uottawa.ca' },
    { id: 'queens', name: 'Queens University', province: 'ON', domain: 'queensu.ca' },
    { id: 'western', name: 'Western University', province: 'ON', domain: 'uwo.ca' },
    { id: 'ucalgary', name: 'University of Calgary', province: 'AB', domain: 'ucalgary.ca' },
    { id: 'simon', name: 'Simon Fraser University', province: 'BC', domain: 'sfu.ca' },
    { id: 'uvic', name: 'University of Victoria', province: 'BC', domain: 'uvic.ca' },
    { id: 'dal', name: 'Dalhousie University', province: 'NS', domain: 'dal.ca' },
    { id: 'concordia', name: 'Concordia University', province: 'QC', domain: 'concordia.ca' },
    { id: 'polymtl', name: 'Polytechnique Montreal', province: 'QC', domain: 'polymtl.ca' },
    { id: 'ets', name: 'École de technologie supérieure', province: 'QC', domain: 'etsmtl.ca' },
    { id: 'carleton', name: 'Carleton University', province: 'ON', domain: 'carleton.ca' },
    { id: 'ryerson', name: 'Toronto Metropolitan University', province: 'ON', domain: 'torontomu.ca' },
    { id: 'yorku', name: 'York University', province: 'ON', domain: 'yorku.ca' },
    { id: 'guelph', name: 'University of Guelph', province: 'ON', domain: 'uoguelph.ca' },
    { id: 'windsor', name: 'University of Windsor', province: 'ON', domain: 'uwindsor.ca' },
    { id: 'manitoba', name: 'University of Manitoba', province: 'MB', domain: 'umanitoba.ca' },
    { id: 'usask', name: 'University of Saskatchewan', province: 'SK', domain: 'usask.ca' },
    { id: 'mun', name: 'Memorial University of Newfoundland', province: 'NL', domain: 'mun.ca' },
    { id: 'unb', name: 'University of New Brunswick', province: 'NB', domain: 'unb.ca' },
  ]
};

// Get flat list of all universities
export const getAllUniversities = () => {
  return [
    ...universities.usa.map(u => ({ ...u, country: 'USA' })),
    ...universities.canada.map(u => ({ ...u, country: 'Canada' }))
  ];
};

// Engineering specializations for graduate students
export const engineeringFields = [
  { id: 'cs', name: 'Computer Science' },
  { id: 'ce', name: 'Computer Engineering' },
  { id: 'ee', name: 'Electrical Engineering' },
  { id: 'me', name: 'Mechanical Engineering' },
  { id: 'civil', name: 'Civil Engineering' },
  { id: 'chem', name: 'Chemical Engineering' },
  { id: 'aero', name: 'Aerospace Engineering' },
  { id: 'bio', name: 'Biomedical Engineering' },
  { id: 'env', name: 'Environmental Engineering' },
  { id: 'ie', name: 'Industrial Engineering' },
  { id: 'mse', name: 'Materials Science & Engineering' },
  { id: 'nuke', name: 'Nuclear Engineering' },
  { id: 'se', name: 'Software Engineering' },
  { id: 'ds', name: 'Data Science' },
  { id: 'ai', name: 'Artificial Intelligence / ML' },
  { id: 'cyber', name: 'Cybersecurity' },
  { id: 'robotics', name: 'Robotics' },
  { id: 'systems', name: 'Systems Engineering' },
  { id: 'telecom', name: 'Telecommunications' },
  { id: 'other', name: 'Other Engineering Field' }
];

// Countries of origin (common for international students)
export const countriesOfOrigin = [
  { id: 'india', name: 'India' },
  { id: 'china', name: 'China' },
  { id: 'bangladesh', name: 'Bangladesh' },
  { id: 'pakistan', name: 'Pakistan' },
  { id: 'nepal', name: 'Nepal' },
  { id: 'srilanka', name: 'Sri Lanka' },
  { id: 'nigeria', name: 'Nigeria' },
  { id: 'iran', name: 'Iran' },
  { id: 'vietnam', name: 'Vietnam' },
  { id: 'korea', name: 'South Korea' },
  { id: 'taiwan', name: 'Taiwan' },
  { id: 'brazil', name: 'Brazil' },
  { id: 'mexico', name: 'Mexico' },
  { id: 'colombia', name: 'Colombia' },
  { id: 'turkey', name: 'Turkey' },
  { id: 'egypt', name: 'Egypt' },
  { id: 'saudi', name: 'Saudi Arabia' },
  { id: 'uae', name: 'United Arab Emirates' },
  { id: 'indonesia', name: 'Indonesia' },
  { id: 'philippines', name: 'Philippines' },
  { id: 'thailand', name: 'Thailand' },
  { id: 'japan', name: 'Japan' },
  { id: 'germany', name: 'Germany' },
  { id: 'france', name: 'France' },
  { id: 'uk', name: 'United Kingdom' },
  { id: 'canada', name: 'Canada' },
  { id: 'other', name: 'Other' }
];

// Get all users from localStorage
const getUsers = () => {
  const users = localStorage.getItem(USERS_KEY);
  return users ? JSON.parse(users) : [];
};

// Save users to localStorage
const saveUsers = (users) => {
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
};

// Generate unique ID
const generateId = () => {
  return 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

// Validate .edu or .ca email (for universities)
export const isValidUniversityEmail = (email) => {
  const emailLower = email.toLowerCase();
  // Accept .edu (USA) or .ca (Canada) domains
  return emailLower.endsWith('.edu') || emailLower.endsWith('.ca');
};

// Legacy function for backward compatibility
export const isValidSPUEmail = isValidUniversityEmail;

// Check if user is admin
export const isAdmin = (email) => {
  return email?.toLowerCase() === ADMIN_EMAIL.toLowerCase();
};

// Register new user
export const registerUser = (userData) => {
  const { name, email, password, studentId, phone, university, field, countryOfOrigin, graduationYear } = userData;

  // Validate email
  if (!isValidUniversityEmail(email)) {
    throw new Error('Please use your university email address (.edu or .ca)');
  }

  const users = getUsers();

  // Check if email already exists
  if (users.find(u => u.email.toLowerCase() === email.toLowerCase())) {
    throw new Error('An account with this email already exists');
  }

  const newUser = {
    id: generateId(),
    name,
    email: email.toLowerCase(),
    password, // In production, this should be hashed
    studentId,
    phone,
    university: university || null,
    field: field || null,
    countryOfOrigin: countryOfOrigin || null,
    graduationYear: graduationYear || null,
    isVerified: false,
    verifiedAt: null,
    registeredAt: new Date().toISOString(),
    expiresAt: new Date(Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000).toISOString(),
    profilePic: null,
  };

  users.push(newUser);
  saveUsers(users);

  // Auto-login after registration
  const { password: _, ...userWithoutPassword } = newUser;
  localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(userWithoutPassword));

  return userWithoutPassword;
};

// Login user
export const loginUser = (email, password) => {
  const users = getUsers();
  const user = users.find(u => u.email.toLowerCase() === email.toLowerCase());

  if (!user) {
    throw new Error('No account found with this email');
  }

  if (user.password !== password) {
    throw new Error('Incorrect password');
  }

  // Check if unverified user has expired
  if (!user.isVerified && new Date(user.expiresAt) < new Date()) {
    // Remove expired user
    const updatedUsers = users.filter(u => u.id !== user.id);
    saveUsers(updatedUsers);
    throw new Error('Your account has expired. Please register again.');
  }

  const { password: _, ...userWithoutPassword } = user;
  localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(userWithoutPassword));

  return userWithoutPassword;
};

// Logout user
export const logoutUser = () => {
  localStorage.removeItem(CURRENT_USER_KEY);
};

// Get current logged in user
export const getCurrentUser = () => {
  const user = localStorage.getItem(CURRENT_USER_KEY);
  if (!user) return null;

  const parsedUser = JSON.parse(user);

  // Refresh user data from storage
  const users = getUsers();
  const freshUser = users.find(u => u.id === parsedUser.id);

  if (!freshUser) {
    localStorage.removeItem(CURRENT_USER_KEY);
    return null;
  }

  // Check expiry for unverified users
  if (!freshUser.isVerified && new Date(freshUser.expiresAt) < new Date()) {
    localStorage.removeItem(CURRENT_USER_KEY);
    return null;
  }

  const { password: _, ...userWithoutPassword } = freshUser;
  return userWithoutPassword;
};

// Update current user in localStorage (for real-time verification updates)
export const refreshCurrentUser = () => {
  const currentUser = getCurrentUser();
  if (currentUser) {
    localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(currentUser));
  }
  return currentUser;
};

// Get all pending verification requests (admin only)
export const getPendingUsers = () => {
  const users = getUsers();
  return users
    .filter(u => !u.isVerified)
    .map(({ password, ...user }) => user)
    .sort((a, b) => new Date(b.registeredAt) - new Date(a.registeredAt));
};

// Get all verified users (admin only)
export const getVerifiedUsers = () => {
  const users = getUsers();
  return users
    .filter(u => u.isVerified)
    .map(({ password, ...user }) => user)
    .sort((a, b) => new Date(b.verifiedAt) - new Date(a.verifiedAt));
};

// Get all users (admin only)
export const getAllUsers = () => {
  const users = getUsers();
  return users.map(({ password, ...user }) => user);
};

// Verify user (admin only)
export const verifyUser = (userId) => {
  const users = getUsers();
  const userIndex = users.findIndex(u => u.id === userId);

  if (userIndex === -1) {
    throw new Error('User not found');
  }

  users[userIndex].isVerified = true;
  users[userIndex].verifiedAt = new Date().toISOString();
  users[userIndex].expiresAt = null; // Verified users don't expire

  saveUsers(users);

  return users[userIndex];
};

// Reject/Delete user (admin only)
export const rejectUser = (userId) => {
  const users = getUsers();
  const updatedUsers = users.filter(u => u.id !== userId);
  saveUsers(updatedUsers);
};

// Get days remaining before expiry
export const getDaysRemaining = (expiresAt) => {
  if (!expiresAt) return null;
  const now = new Date();
  const expiry = new Date(expiresAt);
  const diffTime = expiry - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(0, diffDays);
};

// Clean up expired users (can be called periodically)
export const cleanupExpiredUsers = () => {
  const users = getUsers();
  const now = new Date();
  const activeUsers = users.filter(u => {
    if (u.isVerified) return true;
    return new Date(u.expiresAt) > now;
  });
  saveUsers(activeUsers);
  return users.length - activeUsers.length; // Return number of removed users
};

// Get user stats (admin)
export const getUserStats = () => {
  const users = getUsers();

  return {
    total: users.length,
    verified: users.filter(u => u.isVerified).length,
    pending: users.filter(u => !u.isVerified).length,
    expiringSoon: users.filter(u => {
      if (u.isVerified) return false;
      const daysLeft = getDaysRemaining(u.expiresAt);
      return daysLeft !== null && daysLeft <= 2;
    }).length,
  };
};

// Google Sign-In - Register/Login with Google account
export const googleSignIn = (googleUser) => {
  const { email, name, picture, sub: googleId } = googleUser;

  // Validate email domain
  if (!isValidUniversityEmail(email)) {
    throw new Error('Please use your university Google account (.edu or .ca email)');
  }

  const users = getUsers();
  let user = users.find(u => u.email.toLowerCase() === email.toLowerCase());

  if (user) {
    // Existing user - update Google info and login
    user.googleId = googleId;
    user.profilePic = picture || user.profilePic;
    user.name = name || user.name;
    saveUsers(users);

    // Check if unverified user has expired
    if (!user.isVerified && new Date(user.expiresAt) < new Date()) {
      const updatedUsers = users.filter(u => u.id !== user.id);
      saveUsers(updatedUsers);
      throw new Error('Your account has expired. Please sign in again to re-register.');
    }

    const { password: _, ...userWithoutPassword } = user;
    localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(userWithoutPassword));
    return { user: userWithoutPassword, isNewUser: false };
  } else {
    // New user - register with Google
    const newUser = {
      id: generateId(),
      name,
      email: email.toLowerCase(),
      password: null, // Google users don't have passwords
      googleId,
      studentId: null,
      phone: null,
      university: null,
      field: null,
      countryOfOrigin: null,
      graduationYear: null,
      isVerified: false,
      verifiedAt: null,
      registeredAt: new Date().toISOString(),
      expiresAt: new Date(Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000).toISOString(),
      profilePic: picture || null,
    };

    users.push(newUser);
    saveUsers(users);

    const { password: _, ...userWithoutPassword } = newUser;
    localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(userWithoutPassword));
    return { user: userWithoutPassword, isNewUser: true };
  }
};

// Export default object
const userAuth = {
  universities,
  getAllUniversities,
  engineeringFields,
  countriesOfOrigin,
  isValidUniversityEmail,
  isValidSPUEmail, // Legacy
  isAdmin,
  registerUser,
  loginUser,
  logoutUser,
  googleSignIn,
  getCurrentUser,
  refreshCurrentUser,
  getPendingUsers,
  getVerifiedUsers,
  getAllUsers,
  verifyUser,
  rejectUser,
  getDaysRemaining,
  cleanupExpiredUsers,
  getUserStats,
};

export default userAuth;
